import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSRadio } from '@repo/design-system/index'
import classNames from 'classnames'
import { useState } from 'react'
import { HACKLE_FLAG_KEY, useFeatureFlag } from '../../../helpers/hackleHelper'
import { n_purchase } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

const enum PAYMENT_TYPE {
  DOMESTIC = 1, // 국내 결제
  INTERNATIONAL = 2, // 해외 결제
}

const SelectPaymentBody = ({ handleDomesticPayment, handleInternationalPayment }) => {
  const { t } = useTranslation()
  const internationalPaymentOn = useFeatureFlag(HACKLE_FLAG_KEY.WEBINAR_INTERNATIONAL_PAYMENT)

  const [selected, setSelected] = useState<number>(PAYMENT_TYPE.DOMESTIC)

  const itemClassNames = (value) =>
    classNames('border-1 rounded-[8px] py-[16px] px-[16px] min-w-full h-[90px]', {
      'bg-gray-50 border-purple-500': selected == value,
      'border-gray-300': selected != value,
    })
  return (
    <div className="">
      <div className="">
        <DSRadio controlSelected={[selected, setSelected]} containerClassName="flex flex-col space-y-[8px]">
          <DSRadio.Item value={PAYMENT_TYPE.DOMESTIC} className={itemClassNames(PAYMENT_TYPE.DOMESTIC)}>
            <span className="Title2-18Bd text-gray-800 ml-[10px]">{t(n_purchase.payment.korean_card)}</span>
          </DSRadio.Item>
          {internationalPaymentOn && (
            <DSRadio.Item value={PAYMENT_TYPE.INTERNATIONAL} className={itemClassNames(PAYMENT_TYPE.INTERNATIONAL)}>
              <div className="flex flex-col ml-[10px]">
                <span className="Title2-18Bd text-gray-800">{t(n_purchase.payment.foreign_card)}</span>
                <span className="Body1-16Md mt-[4px] text-gray-500">{t(n_purchase.payment.explanation_usd)}</span>
              </div>
            </DSRadio.Item>
          )}
        </DSRadio>
      </div>
      <div className="mt-[32px]">
        <DSButton
          type={BUTTON_TYPE.SOLID}
          size={BUTTON_SIZE.LG}
          onClick={(e) => (selected == PAYMENT_TYPE.DOMESTIC ? handleDomesticPayment(e) : handleInternationalPayment())}
        >
          <DSButton.Label>{t(n_purchase.btn_submit_order)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default SelectPaymentBody
